import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import _ from 'lodash';
import Error from 'Components/Error';
import s from './Textarea.module.scss';

const Textarea = ({
    name,
    label,
    id,
    value,
    placeholder,
    maxLength,
    error,
    errors,
    register,
}) => {

    const fieldId = _.isEmpty(id) ? name : id;

    const classes = classNames(
        s['Textarea'],
        {[s['Textarea--Error']]: errors[name] || error},
    );

    return (
        <div className={classes}>
            {!_.isEmpty(label) &&
                <label className={s['Textarea__Label']} htmlFor={fieldId}>{label}</label>
            }
            <textarea
                className={s['Textarea__Field']}
                name={name}
                id={fieldId}
                maxLength={maxLength}
                placeholder={placeholder}
                defaultValue={value}
                {...register}
            />
            <ErrorMessage errors={errors} name={name} as={<Error />} />
        </div>
    );
};

Textarea.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    errors: PropTypes.object,
    error: PropTypes.bool,
    register: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
};

Textarea.defaultProps = {
    name: '',
    label: '',
    id: '',
    value: '',
    placeholder: null,
    maxLength: null,
    errors: {},
    error: false,
    register: null,
    onChange: null,
    onBlur: null,
};

export default Textarea;
